<!--<angular2-multiselect [data]="itemList" [(ngModel)]="selectedItems"  [settings]="settings" (onSelect)="onItemSelect($event)"-->
<!--                      (onDeSelect)="OnItemDeSelect($event)" (onSelectAll)="onSelectAll($event)" (onDeSelectAll)="onDeSelectAll($event)">-->
<!--  <c-search>-->
<!--    <ng-template>-->
<!--      <input type="text" (keyup.enter)="onSearch($event)" placeholder="Search Service Points.." style="border: none;width: 100%; height: 100%;outline: none;"/>-->
<!--    </ng-template>-->
<!--  </c-search>-->
<!--  <c-item>-->
<!--    <ng-template let-item="item" >-->
<!--      <label style="color: #333;">{{item.globalID}} - {{item.servicePointName}}</label>-->
<!--&lt;!&ndash;      <label>{{item.servicePointName}}</label>&ndash;&gt;-->
<!--    </ng-template>-->
<!--  </c-item>-->
<!--</angular2-multiselect>-->

<!--<p>Use <b>typeahead</b> to subscribe to search term and load async items.</p>-->
<!--<label>Multi select + Typeahead + Custom items (tags)</label>-->

<ng-select
  class="custom gid-select"
  [items]="servicePoints$ | async"
  bindLabel="globalID"
  [addTag]="false"
  [multiple]="true"
  [hideSelected]="true"
  [trackByFn]="trackByFn"
  [minTermLength]="1"
  [maxSelectedItems]="maxItems"
  [loading]="spsLoading"
  typeToSearchText="Type to search..."
  [typeahead]="spsInput$"
  [(ngModel)]="selectedItems"
  (change)="onItemSelect($event)"
  dropdownPosition="auto"
  appendTo="body"
>
  <ng-template ng-label-tmp let-item="item" let-clear="clear">
    <span class="ng-value-label">
      {{ item.globalID }} - {{ item.servicePointName }}</span
    >
    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true"
      >×</span
    >
  </ng-template>
  <ng-template
    ng-option-tmp
    let-item="item"
    let-index="index"
    let-search="searchTerm"
    >{{ item.globalID }} - {{ item.servicePointName }}</ng-template
  >
</ng-select>

<!--<div style="margin-bottom:100px">-->
<!--  Selected servicePoints: {{selectedItems | json}}-->
<!--</div>-->

<!-- <ng-select [(ngModel)]="selectedItems">
  <ng-option *ngFor="let val of itemList" [value]="val.id">
    {{ val.globalID + ' ' + val.servicePointName }}
  </ng-option>
</ng-select>

<div style="margin-bottom: 100px">
  Selected servicePoints: {{ selectedItems | json }}
</div> -->
